import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Box from '@ntuctech/devex-tangram/Box';

const FormFooterSC = styled(Box)`
  * {
    color: #696969;
  }
`;

function FormFooter({ children }) {
  return <FormFooterSC>{children}</FormFooterSC>;
}

FormFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormFooter;
